"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toastProvider = void 0;
const provider_1 = require("@/ui/provider");
const utils_1 = require("@/common/utils/utils");
const toast_1 = require("./toast");
class ToastProvider extends provider_1.Provider {
    constructor() {
        super("toast-provider");
        this._timer = null;
    }
    showToast(text, delay = 3000, variant = "secondary") {
        this.closeToast();
        const id = `toast.${(0, utils_1.generateRandomID)()}`;
        const toast = new toast_1.Toast(this._providerElement, { text, variant, id });
        this._registerComponent(id, toast);
        if (delay !== Infinity) {
            this._timer = setTimeout(() => {
                this._removeComponent(id);
                this._timer = null;
            }, delay);
        }
        return toast;
    }
    showTitleToast(title, text, delay = 3000, variant = "secondary") {
        this.closeToast();
        const id = `toast.${(0, utils_1.generateRandomID)()}`;
        const toast = new toast_1.Toast(this._providerElement, { title, text, variant, id });
        this._registerComponent(id, toast);
        if (delay !== Infinity) {
            this._timer = setTimeout(() => {
                this._removeComponent(id);
                this._timer = null;
            }, delay);
        }
        return toast;
    }
    closeToast() {
        this._clearComponents();
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
    }
    dispose() {
        clearTimeout(this._timer);
        this._timer = null;
        super.dispose();
    }
}
exports.toastProvider = (0, provider_1.registerProvider)(ToastProvider);
